import classNames from "classnames";
import Cleave from "cleave.js/react";
import { SmallIcon } from "Components/SmallIcon";
import { useField } from "formik";
import React from "react";
import { doesMetaHaveError, renderErrorMessage } from "./Tools";

function TelInput(props: {
  fieldName: string;
  placeholder?: string;
  textboxIcon: React.ReactNode;
}) {
  const [field, meta] = useField(props.fieldName);
  return (
    <div className="field">
      <div className="control is-expanded has-icons-left">
        <Cleave
          id={props.fieldName}
          type="tel"
          className={classNames("input", {
            "input-validation-error": doesMetaHaveError(meta),
          })}
          options={{
            numericOnly: true,
            blocks: [0, 3, 3, 4],
            delimiters: ["(", ") ", "-"],
          }}
          {...field}
          value={field.value || ""}
        />
        {renderErrorMessage(meta)}
        {props.textboxIcon}
      </div>
    </div>
  );
}

export function PhoneInput(props: { fieldName: string; placeholder?: string }) {
  return (
    <TelInput
      {...props}
      textboxIcon={<SmallIcon className="is-left" name="fa-phone" />}
    />
  );
}

export function FaxInput(props: { fieldName: string; placeholder?: string }) {
  return (
    <TelInput
      {...props}
      textboxIcon={<SmallIcon className="is-left" name="fa-fax" />}
    />
  );
}
